import React from 'react';
import {
  Box,
  Card,
  CardActions,
  Skeleton,
} from '@mui/material';

const Shimmer = () => (
  <style>{`
    @keyframes shimmer {
      0% {
        background-position: -200px 0;
      }
      100% {
        background-position: 200px 0;
      }
    }
    .shimmer {
      background: linear-gradient(to right, #f6f7f8 4%, #edeef1 25%, #f6f7f8 36%);
      background-size: 200px 100%;
      animation: shimmer 1.5s infinite linear;
    }
  `}</style>
);

export default function DisplayCardShimmer() {
  return (
    <>
      <Shimmer />
      <Card
        elevation={3}
        sx={{
          borderRadius: 2,
          textAlign: 'center',
          py: 0,
          maxWidth: 340,
          minWidth: 340,
          minHeight: 500,
          maxHeight: 500,
          display: 'flex',
          flexDirection: 'column',
          justifyContent: 'space-between',
          position: 'relative',
          overflow: 'hidden',
        }}
      >
        <Box sx={{ width: '100%', height: 200, position: 'relative', overflow: 'hidden' }}>
          <Skeleton variant="rectangular" width="100%" height="100%" className="shimmer" />
        </Box>

        <Box
          sx={{
            position: 'relative',
            px: 2,
            pb: 2,
            pt: 2,
            flexGrow: 1,
            textAlign: 'center',
          }}
        >
          <Skeleton variant="text" width="60%" height={32} sx={{ margin: '0 auto 0.5rem' }} className="shimmer" />
          <Skeleton variant="text" width="80%" height={20} sx={{ margin: '0 auto 0.5rem' }} className="shimmer" />
          <Skeleton variant="text" width="50%" height={20} sx={{ margin: '0 auto 0.5rem' }} className="shimmer" />
          <Skeleton variant="text" width="40%" height={20} sx={{ margin: '0 auto 0.5rem' }} className="shimmer" />
          <Skeleton variant="rectangular" width="100%" height={60} sx={{ margin: '1rem auto 0' }} className="shimmer" />
        </Box>

        <CardActions sx={{ justifyContent: 'center' }}>
          <Skeleton variant="text" width={50} height={30} className="shimmer" />
          <Skeleton variant="text" width={30} height={30} className="shimmer" />
          <Skeleton variant="text" width={60} height={30} className="shimmer" />
        </CardActions>
      </Card>
    </>
  );
}